module.exports = "/images/gallery-add.svg?6e56b13f3f77426b5954a71b16f25295";